<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
            <Button label="차트" icon="pi pi-chart-line" class="p-button-secondary mr-2" @click="chartPopup($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="publicId" v-model="searchParams.publicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="publicId">업체소재지</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="custCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                        :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field-0 p-float-label m-2" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>시작일자</label>
                    </div>
                     <label style="padding-left: 0.2em; padding-right: 0.2em;">~</label>
                    <div class="p-field p-float-label m-2" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>종료일자</label>
                    </div>
                </div> 
            </template>

            <template #end>
            </template>
        </Toolbar>

        <DataTable id="dt" ref="dt" :value="dataList" showGridlines scrollable
            class="p-datatable-sm" :loading="loading" rowIndexVar="rowIndex" 
            scrollHeight="79vh" responsiveLayout="scroll">
            <Column field="rowNo" header="No" style="min-width:3em; max-width:3em" exportFooter=" "/>
            <Column field="publicId" header="업체소재지" exportFooter=" ">
                <template #body="{data}">
                    {{(publicCodes.find(e=>e.code == data.publicId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="corpId" header="업체ID" :sortable="true" exportFooter=" "></Column>
            <Column field="corpNm" header="업체명" :sortable="true" exportFooter=" "></Column>
            <Column field="allSum" header="합계" :sortable="true" exportFooter=" ">
            <template #body="{ data, field }">
                <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
            </template>
            </Column>
            <Column field="sumTot" header="수입금액" :sortable="true" exportFooter=" ">
            <template #body="{ data, field }">
                <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
            </template>
            </Column>
            <Column field="expAmt" header="비용금액" :sortable="true" exportFooter=" ">
            <template #body="{ data, field }">
                <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
            </template>
            </Column>
            <Column field="gasAmt" header="주유금액" :sortable="true" exportFooter=" ">
            <template #body="{ data, field }">
                <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
            </template>
            </Column>
        </DataTable>

        <Dialog :visible="chartPopupVisible" :style="{width: '1500px'}" :contentStyle="{height: '6500px'}" :closable="false">
                <h2 style="text-align: center;">업체별전자신고집계</h2>

                <div class="card" style=" width:99%; height:99%; padding:0; margin:0;">
                    <vue-highcharts
                        type="chart"
                        :options="bar_chartOptions"
                        :redrawOnUpdate="true"
                        :oneToOneUpdate="false"
                        :animateOnUpdate="true"
                        style="display:block; height: 95%; width:100%;"
                        />
                </div>

            <template #footer>
                <Button label="닫기" icon="pi pi-check" @click="closeDialog" />
            </template>
        </Dialog>

    </div>
</template>

<script>
import { ref, onMounted, reactive , computed} from 'vue';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA401030Service from '@/service/ma/MA401030Service';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';


export default {

    setup() { 
        
        onMounted(() => {
            searchParams.compSeq = 1;

             // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                    searchParams.publicId = user.publicId;  // 업체소재지
                    // 업체 목록을 얻어온다
                    custService.getCodeList(searchParams).then(data => {
                        custCodes.value = data;
                        // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                        searchParams.corpId = user.custSeq;
                         if(user.userGbCd != null) {
                            // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                            if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                isCustUser.value = true;    
                            }
                            // 시군구담당자인 경우
                            if(user.userGbCd == 'ct_mngr') {
                                searchParams.ctrPublicId = user.publicId;
                            }
                        }  
                    });
                }
            }

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);            
            searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const ma401030Service = new MA401030Service();
        const searchParams = reactive({publicId:null,corpId:null,fromDate: null, toDate: null});
        const dataList = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const useOilTagCodes = ref([]);
        // 로딩, 메시지
        const toast = useToast();
        const loading = ref(false);



        const yns = ref([
            {codeNm: '사용', code: 1},
            {codeNm: '중지', code: 2}
        ])
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 
        
        const chartPopupVisible = ref(false);
        const charBarData = ref([{}]);

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchMA401030();
                    break;
                default:
            }
        }

        const searchMA401030 = () => {
            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            loading.value = true;
            ma401030Service.getList(searchParams).then(data => { 
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});             
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const changePublicId= () => {
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            if(searchParams.publicId != null) {
                custService.getCodeList(searchParams).then(data => {
                    custCodes.value = data;
                });
            }
            else {
                custCodes.value = [];
            }
            searchParams.corpId = null;
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 차트 팝업
        const chartPopup = () => {
            if(dataList.value.length === 0){
                toast.add({severity:'warn', summary:'데이터 확인', detail:'업체별전자신고집계조회 정보를 먼저 검색 후 차트를 확인 할 수 있습니다.', life:2000});
            }else{
                chartPopupVisible.value = true;

                charBarData.value = getDataTableToMultiBar(dataList.value,"corpNm","allSum","sumTot","expAmt","gasAmt");
            }
        }

        // 차트를 닫음
        const closeDialog = () => {
            chartPopupVisible.value = false;
        }

        // 차트 옵션 처리 
        const bar_chartOptions = computed(() => ({
            chart: {
                type: 'column',
            },
            title: {
                text: null,
            },
            xAxis: {
                type: 'category',
                labels: {
                    rotation: -45,
                    style: {
                        fontSize: '13px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            yAxis: {
                title: {
                    text: null,
                },
                labels: {
                    formatter: function() {
                        return formatToPrice(this.value/10000)+ "만원";
                    }
                },
            },
            tooltip: {
                formatter: function() {
                        let s;
                        s = this.point.name;
                        s += '<br/><span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + '금액:' + formatToPrice(this.point.y) + '원';
                        return s;
                    }
            },
            series: charBarData.value,
            credits: {//워터마크 제거
                enabled: false
            },
        }));

        //차트 막대 데이터 가공처리
        const getDataTableToMultiBar = (obj,corpNm,allSum,sumTot,expAmt,gasAmt) => {
            var r = new Array();

            var as = {name: '합계', data: []};
            var st = {name: '수입금액', data: []};
            var ea = {name: '비용금액', data: []};
            var ga = {name: '주유금액', data: []};

            for(let key=obj.length-1; key>=0; key--){
                as.data[key] = new Array(obj[key][corpNm], Number(obj[key][allSum]));
                st.data[key] = new Array(obj[key][corpNm], Number(obj[key][sumTot]));
                ea.data[key] = new Array(obj[key][corpNm], Number(obj[key][expAmt]));
                ga.data[key] = new Array(obj[key][corpNm], Number(obj[key][gasAmt]));
            }

            r[0] = as;
            r[1] = st;
            r[2] = ea;
            r[3] = ga;
            
            return r;
        };

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, isCustUser, loading,
            yns, custCodes, formatToPrice,
            btnAct, downloadExcel, exportCSV, changePublicId, chartPopup, bar_chartOptions, closeDialog, chartPopupVisible
        }

    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
